import * as H from 'history'

/*
  This is a bug fix for the history package.
  history.push() decodes link before pushing to the browser history.
  When the user refreshes they receive a 400 if percentage used in search term
  Issue: https://github.com/ReactTraining/history/issues/505

  Solution is to replace the history with an encoded url afterwards
*/
const pushHistory = (history: H.History, link: string) => {
  history.push(link)
  window.history.replaceState(null, '', link)
}

export default pushHistory
